import { Link, classnames as cx } from "@mna/react";
import Form from "@mna/react-ui/Form";
import schema from "@mna/schema";
import Switch from "react-switch";
import IconX from '../assets/icons/x.svg'
import i18next from "i18next";
import { getDayData } from '@mna/calendar'
import getmonthname from '../pages/find-care-options/start/GetMonth'
import { Trans } from "react-i18next";
import {
  checkAndGetLocalStorageValue,
  checkAndGetSessionStorageValue,
  getDate,
  check,
  getDateWithIso
} from "../features/utils";
import DatePicker from 'rmc-date-picker'
import Modal from '@mna/react-ui/Modal'
import { Component } from "react";
// import PhoneInput2 from "./PhoneInput";
import PhoneInput2 from "react-phone-input-2";
import { telemedicineVendors } from "../server/triage/constants";

const formSchema = schema(({ string, stringOf }) => ({
  consent: stringOf("false"),
  mobile: string,
  email: string,
  effectTo: string,
  effectFrom: string,
  insurance: string,
  policyNum: string,
  username: string,
  phone: string,
}));
var policyFromMinDate = getDateWithIso(new Date(), -1);
var getCurrentDate = getDateWithIso(new Date(), 0);
var policyToMinDate = getDateWithIso(new Date(), 0);
var policyToMaxDate = "";


var policyFromMinDateMobile = getDate(new Date(), -1);
var getCurrentDateMobile = getDate(new Date(), 0);
var policyToMinDateMobile = getDate(new Date(), 0);
var policyToMaxDateMobile = "";

const minDate = new Date(1900, 0, 1)
const maxDate = new Date() // Born today!
const defaultDate = new Date(1960, 0, 1)

const updateMonthDay = (year, month, day) => {
  var updateMonth = month
  var updateDay = day
  if (updateMonth <= 9) {
    updateMonth = "0" + month
  }
  if (updateDay <= 9) {
    updateDay = "0" + day
  }
  return year + "-" + updateMonth + "-" + updateDay

}

const { year, month, day } = getDayData(defaultDate)
var defaultFormattedDOB = updateMonthDay(year, month, day)
var travelDatesFrom = "";
var travelDatesTo = "";
var InsuredBirthday = "";


export default class Telemedicineinfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: true,
      phoneError: true,
      value: '',
      InsuranceDateFrom: false,
      InsuranceDateTo: false,
      InsuredDOB: false

    };
    this.onChange = this.onChange.bind(this)
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(checked) {
    this.setState({ checked });
  }

  onChange(e) {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ value: e.target.value })
    }
  }

  openModel = () => {
    this.setState({
      showModal: true
    });
  }

  closeModal = () =>
    this.setState({
      showModal: false,
    });

  openModelEffectTo = () => {
    this.setState({
      showModelEffectTo: true
    });
  }

  closeModalEffectTo = () =>
    this.setState({
      showModelEffectTo: false,
    });

  openModelDOB = () => {
    this.setState({
      showModelDOB: true
    });
  }

  closeModalDOB = () =>
    this.setState({
      showModelDOB: false,
    });

  render() {
    const {
      state,
      actions,
      history,
      setState,
      previousStepName,
      nextStepName,
    } = this.props;
    const { triageRequest } = state;
    const telemedicine = "Telemedicine";
    const conciergeCare = "Concierge Care";
    state.triageRequest.activeMenu = "care-options";
    if(!state.isFacility){
      var flagEl = document.getElementsByClassName("selected-flag")[0];
      if (flagEl) flagEl.setAttribute('aria-label','flag name');
    }
    return (
      <div className="content-width mt-3 contact-container">
        <h1 className="text-left standby-page-header-title">
          <Trans i18nKey="findcareoption.Careoptions.telemedicine.connectiondetails">
            Let's make sure we have the best ways to get in contact with you.
          </Trans>
        </h1>
        <Form
          fields={triageRequest.serviceRequest}
          className = "send-info-scrollbar"
          onValidate={(data) => {
            const errors = {};
            const required = "REQUIRED";
            var scheme = formSchema(data);
            if (scheme !== null) {
              if (checkAndGetSessionStorageValue("IsValidUser") === "true") {
                if (scheme.username === required) errors.username = required;
                if (scheme.email === required) errors.email = required;
                if (state.triageRequest.EffectFrom === undefined || (state.triageRequest.EffectFrom).length === 0  || data.effectFrom === '') {
                  errors.effectFrom = required;
                }
                if (state.triageRequest.EffectTo === undefined || (state.triageRequest.EffectTo).length === 0  || data.effectTo === '') {
                  errors.effectTo = required;
                }

                if (state.triageResponse.vendorsList[0] && state.triageResponse.vendorsList[0].nameLocalization !== undefined) {
                  if (
                    state.triageResponse.vendorsList[0].nameLocalization
                      .localizations[0].value ===
                    telemedicineVendors.oneEightHundredMD || state.triageResponse.vendorsList[0].nameLocalization
                      .localizations[0].value ===
                    telemedicineVendors.Maple
                  ) {
                    if (
                      /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(
                        data.phone
                      ) === false
                    ) {
                      this.setState({ phoneError: false });
                      errors.phone = required;
                    }
                  } else {
                    if ((data.phone).length <= 4) {
                      errors.phone = required;
                    }
                  }
                } else {
                  if ((data.phone).length <= 4) {
                    errors.phone = required;
                  }
                }
                if (scheme.insurance === required) errors.insurance = required;
                if (scheme.policyNum === required) errors.policyNum = required;

                if (Object.keys(errors).length) return errors;
              }
              if (
                checkAndGetLocalStorageValue("careoption") !== conciergeCare
              ) {
                if (scheme.email === required) errors.email = required;
              }

              if (checkAndGetLocalStorageValue("careoption") == telemedicine) {
                if (state.triageResponse.vendorsList[0] && state.triageResponse.vendorsList[0].nameLocalization !== undefined) {
                  if (
                    state.triageResponse.vendorsList[0].nameLocalization
                      .localizations[0].value ===
                    telemedicineVendors.oneEightHundredMD || state.triageResponse.vendorsList[0].nameLocalization
                      .localizations[0].value ===
                    telemedicineVendors.Maple
                  ) {
                    if (
                      /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(
                        data.phone
                      ) === false
                    ) {
                      this.setState({ phoneError: false });
                      errors.phone = required;
                    }
                  } else {
                    if ((data.phone).length <= 4) errors.phone = required;
                  }
                }
              }
              else {
                if ((data.phone).length <= 4) errors.phone = required;
              }

              if (Object.keys(errors).length) return errors;
            }
          }}
          onSubmit={(data) => {
            actions.setTriageServiceRequest(data);
            state.triageRequest.data = data;
            gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
            state.triageRequest.insuredInfo =
              data.insuredOn ||
              data.insuredBirthDate ||
              data.sex ||
              data.relation;
            state.triageRequest.checked = this.state.checked;
            if (
              checkAndGetSessionStorageValue("IsValidUser") === "true" &&
              this.state.phoneError && checkAndGetSessionStorageValue("isTravelAid2") === "true"
            ) {
              actions.updateLogTelemedCordination();

              if (
                checkAndGetLocalStorageValue("careoption") === telemedicine &&
                state.triageResponse.vendorsList[0].nameLocalization
                  .localizations[0].value ==
                telemedicineVendors.oneEightHundredMD &&
                this.state.phoneError
              ) {
                history.push(`/find-care-options/telemed-pharma-prompt`);
              } else if (
                checkAndGetLocalStorageValue("careoption") === telemedicine &&
                this.state.phoneError
              ) {
                history.push(`/find-care-options/telemed-pharma-prompt`);
              } else {
                if (this.state.phoneError === true) {
                  history.push(`/find-care-options/patientdetails-confo-screen`);
                }
              }
            } else {
              if (
                checkAndGetLocalStorageValue("careoption") === telemedicine &&
                state.triageResponse.vendorsList[0].nameLocalization
                  .localizations[0].value ==
                telemedicineVendors.oneEightHundredMD &&
                this.state.phoneError
                //1-800 MD
              ) {
                actions.updateLogTelemedCordination();
                history.push(`/find-care-options/telemed-pharma-prompt`);
              } else if (
                checkAndGetLocalStorageValue("careoption") === conciergeCare &&
                this.state.phoneError
              ) {
                history.push(`/find-care-options/patientdetails-confo-screen`);
              } else {
                if (this.state.phoneError === true) {
                  actions.updateLogTelemedCordination();
                  history.push(`/find-care-options/patientdetails-confo-screen`);
                }
              }
            }
          }}
        >
          {({ fields, invalidFields, isValid }) => (
            <div>
              <>
                {checkAndGetSessionStorageValue("IsValidUser") === "true" ? (
                  <>
                    <h5>
                      <Trans i18nKey="Aboutyou">About you:</Trans>
                    </h5>
                    <input
                      type="text"
                      name="username"
                      placeholder={i18next.t("findcareoption.Start.Name")}
                      defaultValue={state.triageRequest.data.username}
                      className={cx(invalidFields.username ? "is-error" : "")}
                    />
                  </>
                ) : (
                  <>
                    {checkAndGetLocalStorageValue("careoption") ==
                      telemedicine ? (
                      <input
                        type="email"
                        name="email"
                        placeholder={i18next.t(
                          "findcareoption.Careoptions.Email"
                        )}
                        defaultValue={
                          state.triageRequest.data
                            ? state.triageRequest.data.email
                            : fields.email
                        }
                        className={invalidFields.email ? "is-error" : ""}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}

                <div className="pt-1 pb-2">
                  <PhoneInput2
                    country={!state.triageResponse.vendorsList[0] || !state.triageResponse.vendorsList[0].nameLocalization
                      ? "us" : state.triageResponse.vendorsList[0].nameLocalization
                        .localizations[0].value ===
                      telemedicineVendors.oneEightHundredMD ? "us" : state.triageResponse.vendorsList[0].nameLocalization
                        .localizations[0].value ===
                        telemedicineVendors.Maple ? "ca" : ""}

                    onlyCountries={!state.triageResponse.vendorsList[0] || !state.triageResponse.vendorsList[0].nameLocalization
                      ? "" : state.triageResponse.vendorsList[0].nameLocalization
                        .localizations[0].value ===
                        telemedicineVendors.oneEightHundredMD ? ["us", "ca"] : (state.triageResponse.vendorsList[0].nameLocalization
                          .localizations[0].value ===
                          telemedicineVendors.Maple ? ["ca"] : "")}

                    inputProps={{
                      name: "phone",
                    }}
                    inputClass={cx(invalidFields.phone ? "is-error" : "")}
                    value={
                      state.triageRequest.data
                        ? state.triageRequest.data.phone
                        : fields.phone
                    }
                    placeholder={i18next.t(
                      "findcareoption.Careoptions.PhoneNumber"
                    )}
                    onChange={(phone) =>
                      this.setState({ phone, phoneError: true })
                    }
                    isValid={() => {
                      if (!state.triageResponse.vendorsList[0] || !state.triageResponse.vendorsList[0].nameLocalization) {
                        return true;
                      }
                      else {
                        if (state.triageResponse.vendorsList[0].nameLocalization
                          .localizations[0].value ===
                          telemedicineVendors.oneEightHundredMD || state.triageResponse.vendorsList[0].nameLocalization
                            .localizations[0].value ===
                          telemedicineVendors.Maple) {
                          if (this.state.phoneError === false) {
                            return i18next.t("findcareoption.Careoptions.telemedicine.PhoneValidationmsg")
                          }
                          else {
                            return true;
                          }
                        } else {
                          return true;
                        }
                      }
                    }}
                  />
                </div>
                {checkAndGetSessionStorageValue("IsValidUser") === "true" ? (
                  <>
                    <input
                      type="text"
                      name="extensionOrRoomNumber"
                      pattern="[0-9]+"
                      maxLength="5"
                      placeholder={i18next.t(
                        "findcareoption.Careoptions.ExtensionRoom"
                      )}
                      defaultValue={
                        state.triageRequest.data &&
                          state.triageRequest.data.extensionOrRoomNumber
                          ? state.triageRequest.data.extensionOrRoomNumber.trim()
                          : fields.extensionOrRoomNumber
                      }

                    />
                    <input
                      type="email"
                      name="email"
                      placeholder={i18next.t(
                        "findcareoption.Careoptions.Email"
                      )}
                      defaultValue={
                        state.triageRequest.data
                          ? state.triageRequest.data.email
                          : fields.email
                      }
                      className={invalidFields.email ? "is-error" : ""}
                    />
                    <div className="w-col pr-3 pl-0 w-col-6 w-col-tiny-tiny-stack">
                      <h5>
                        <Trans i18nKey="Preferredcontact">
                          Preferred contact method
                        </Trans>
                      </h5>
                    </div>
                    <div className="w-col pt-2 w-col-3 w-col-tiny-tiny-stack radio-button-text">
                      <input
                        id="gender-radio"
                        type="radio"
                        value="Phone"
                        aria-label={i18next.t("Preferredcontact")+" "+i18next.t("findcareoption.Careoptions.Phone")}
                        onChange={(e) => {
                          state.triageRequest.userContact =
                            e.currentTarget.value;
                        }}
                        name="contact"
                        defaultChecked={state.triageRequest.data && state.triageRequest.data.contact === "Phone"
                        ? state.triageRequest.data.contact
                        : fields.contact === "Phone"}
                        pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
                        className="w-radio-input"
                      />
                      <label for="gender-radio" className="w-radio w-radio-textsize">
                        <Trans i18nKey="findcareoption.Careoptions.Phone">
                          Phone
                        </Trans>
                      </label>
                    </div>
                    <div className="w-col pt-2 w-col-3 w-col-tiny-tiny-stack radio-button-text">
                      <input
                        id="gender-radio-1"
                        type="radio"
                        value="Email"
                        aria-label={i18next.t("Preferredcontact")+" "+i18next.t("findcareoption.Careoptions.sendinfo.Email")}
                        onChange={(e) => {
                          state.triageRequest.userContact =
                            e.currentTarget.value;
                        }}
                        name="contact"
                        defaultChecked={state.triageRequest.data && state.triageRequest.data.contact === "Email"
                        ? state.triageRequest.data.contact : fields.contact === "Email"}
                        pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
                        className="w-radio-input"
                      />
                      <label for="gender-radio-1" className="w-radio text-top w-radio-textsize">
                        <Trans i18nKey="findcareoption.Careoptions.sendinfo.Email">
                          Email
                        </Trans>
                      </label>
                    </div>
                    <textarea
                      name="notes"
                      className="mt-2 contact-notes"
                      rows="4"
                      aria-label={i18next.t("findcareoption.Careoptions.notes")}
                      placeholder={i18next.t(
                        "findcareoption.Careoptions.notes"
                      )}
                      defaultValue={state.triageRequest.data && state.triageRequest.data.notes
                        ? state.triageRequest.data.notes : fields.notes}></textarea>
                    <h5>
                      <Trans i18nKey="userregistration.Insurance">
                        Insurance info:
                      </Trans>
                    </h5>

                    <input
                      id="insurance-input"
                      type="text"
                      name="insurance"
                      defaultValue={
                        state.triageRequest.data &&
                          state.triageRequest.data.insurance
                          ? state.triageRequest.data.insurance.trim()
                          : fields.insurance
                      }
                      className={cx(invalidFields.insurance ? "is-error" : "")}
                      placeholder={i18next.t(
                        "userregistration.insurancecarrier"
                      )}
                      pattern="[A-Za-z0-9\s.]{0,}[\S]{1,}[\s]{0,}"
                    />

                    <input
                      id="insurance-policy-input"
                      type="text"
                      name="policyNum"
                      defaultValue={
                        state.triageRequest.data &&
                          state.triageRequest.data.policyNum
                          ? state.triageRequest.data.policyNum.trim()
                          : fields.policyNum
                      }
                      placeholder={i18next.t("userregistration.Policy")}
                      pattern="[A-Za-z0-9\s.]{0,}[\S]{1,}[\s]{0,}"
                      className={cx(invalidFields.policyNum ? "is-error" : "")}
                    />
                    <div className="standby-info-survey-select-birthdate">
                      <div className="w-col pl-0 w-col-6 w-col-tiny-tiny-stack date-field-alignment">
                        <input
                          id="date-effect"
                          type="text"
                          name="effectFrom"
                          min={policyFromMinDate}
                          max={getCurrentDate}
                          // defaultValue={
                          //   state.triageRequest.profile &&
                          //     state.triageRequest.profile.effectFrom
                          //     ? state.triageRequest.profile.effectFrom.trim()
                          //     : fields.effectFrom
                          // }
                          defaultValue={state.triageRequest.EffectFrom}
                          placeholder={i18next.t("findcareoption.Start.travelDateFrom")}
                          className={cx(
                            invalidFields.effectFrom
                              ? "is-error w-input"
                              : "w-input"
                          )}
                          onChange={(e) => {
                            policyToMaxDate = getDateWithIso(
                              new Date(e.currentTarget.value),
                              1
                            );
                            state.triageRequest.EffectFrom = getDateWithIso(
                              new Date(e.currentTarget.value),
                              0
                            );
                            setState({
                              enteredStartdate: e.currentTarget.value,
                            });
                            check(e);
                          }}
                          onFocus={(e) => {
                            e.currentTarget.type = "date";
                          }}
                          onBlur={(e) => {
                            e.currentTarget.placeholder =
                              "Travel Date From: (dd/mm/yyyy)";
                          }}
                        />
                      </div>
                      <div className="w-col pr-0 pl-0 w-col-6 w-col-tiny-tiny-stack">
                        <input
                          id="date-effectto"
                          type="text"
                          name="effectTo"
                          min={policyToMinDate}
                          max={policyToMaxDate}
                          // defaultValue={
                          //   state.triageRequest.profile &&
                          //     state.triageRequest.profile.effectTo
                          //     ? state.triageRequest.profile.effectTo.trim()
                          //     : fields.effectTo
                          // }
                          defaultValue={state.triageRequest.EffectTo}
                          placeholder={i18next.t(
                            "findcareoption.Start.travelDateTo"
                          )}

                          className={cx(
                            invalidFields.effectTo
                              ? "is-error w-input"
                              : "w-input"
                          )}
                          onChange={(e) => {
                            setState({
                              enteredEnddate: e.currentTarget.value,
                            });
                            state.triageRequest.EffectTo = getDateWithIso(
                              new Date(e.currentTarget.value),
                              0
                            );
                            check(e);
                          }}
                          onFocus={(e) => {
                            e.currentTarget.type = "date";
                          }}
                          onBlur={(e) => {
                            e.currentTarget.placeholder =
                              "Travel Date To: (dd/mm/yyyy)";
                          }}
                        />
                      </div>
                    </div>
                    <div className="w-col w-col-tiny-tiny-stack">
                      <div className="column-2 w-col w-col-9 w-col-tiny-tiny-stack insured text-bold">
                      <h5 className="marginTopInsurance">
                        <Trans i18nKey="userregistration.toggle-msg">
                          Are you the primary insured on the policy?
                        </Trans>
                        </h5>
                      </div>
                      <div className="column-2 w-col w-col-3 w-col-tiny-tiny-stack primary-policy">
                        <Switch
                          checked={this.state.checked}
                          onChange={this.handleChange}
                          onColor="#006fd6"
                          onHandleColor="#2693e6"
                          aria-label={i18next.t("userregistration.toggle-msg")}
                          handleDiameter={30}
                          checkedIcon={
                            <div className="Yes-toggle">
                              <Trans i18nKey="userregistration.toggle-yes">
                                Yes
                              </Trans>
                            </div>
                          }
                          uncheckedIcon={
                            <div className="No-Toggle">
                              <Trans i18nKey="userregistration.toggle-no">
                                No
                              </Trans>
                            </div>
                          }
                          className="react-switch"
                          id="material-switch"
                        />
                      </div>
                    </div>
                    {!this.state.checked ? (
                      <div>
                        <h5>
                          <Trans i18nKey="userregistration.primaryInsured">
                            About Primary Insured
                          </Trans>
                        </h5>
                        <input
                          type="text"
                          name="insuredOn"
                          placeholder={i18next.t("findcareoption.Start.Name")}
                          defaultValue={
                            state.triageRequest.data
                              ? state.triageRequest.data.insuredOn
                              : fields.name
                          }
                        />

                        <div className="w-col pr-3 pl-0 w-col-6 w-col-tiny-tiny-stack standby-info-survey-select-birthdate">
                          <input
                            type="text"
                            defaultValue={fields.insuredBirthDate}
                            max={getCurrentDate}
                            className="w-input"
                            onChange={(e) => {
                              state.triageRequest.InsuredBirthday = getDateWithIso(
                                new Date(e.currentTarget.value),
                                0
                              );
                              check(e);
                            }}
                            placeholder={i18next.t("userregistration.user-DOB")}
                            name="insuredBirthDate"
                            pattern="\s{0,}\d{4}-\d{1,2}-\d{1,2}\s{0,}"
                            onFocus={(e) => {
                              e.currentTarget.type = "date";
                            }}
                            onBlur={(e) => {
                              e.currentTarget.placeholder = "DOB (yyyy-dd-mm)";
                            }}
                          />
                        </div>



                        <div className="w-col pt-2 w-col-3 w-col-tiny-tiny-stack radio-button-text">

                          <input
                            id="gender-radio-male"
                            type="radio"
                            value="M"
                            aria-label={i18next.t("userregistration.radio-male")}
                            onChange={(e) => {
                              state.triageRequest.userGenderPrimary =
                                e.currentTarget.value;
                            }}
                            name="sex"
                            defaultChecked={fields.sex === "M"}
                            pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
                            className="w-radio-input"
                          />
                          <label for="gender-radio-male" className="w-radio w-radio-textsize">
                            <Trans i18nKey="userregistration.radio-male">
                              Male
                            </Trans>
                          </label>
                        </div>
                        <div classname="w-col pt-2 w-col-3 w-col-tiny-tiny-stack radio-button-text">
                          <input
                            id="gender-radio-female"
                            type="radio"
                            value="F"
                            aria-label={i18next.t("userregistration.radio-female")}
                            onChange={(e) => {
                              state.triageRequest.userGenderPrimary =
                                e.currentTarget.value;
                            }}
                            name="sex"
                            defaultChecked={fields.sex === "F"}
                            pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
                            className="w-radio-input w-radio-input-female"
                          />
                          <label for="gender-radio-female"  className="w-radio mt-2 w-radio-textsize">
                            <Trans i18nKey="userregistration.radio-female">
                              Female
                            </Trans>
                          </label>
                        </div>

                        <div>
                          <select id="RelationList" 
                          name="relation"
                          aria-label={i18next.t(
                            "userregistration.step4_select.relation"
                          )}
                          defaultValue={fields.relation}>
                            <option value="" disabled selected>
                              {i18next.t(
                                "userregistration.step4_select.relation"
                              )}
                            </option>
                            <option value={i18next.t("userregistration.step4_select.self")}>
                              {i18next.t("userregistration.step4_select.self")}
                            </option>
                            <option value={i18next.t("userregistration.step4_select.child")}>
                              {i18next.t("userregistration.step4_select.child")}{" "}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.employee"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.employee"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.father"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.father"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.mother"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.mother"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.brother"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.brother"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.sister"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.sister"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.fosterchild"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.fosterchild"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.grandfather"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.grandfather"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.grandmother"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.grandmother"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.grandsonorgranddaughter"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.grandsonorgranddaughter"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.lifepartner"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.lifepartner"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.nephew"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.nephew"
                              )}
                            </option>
                            <option value={i18next.t("userregistration.step4_select.niece")}>
                              {i18next.t("userregistration.step4_select.niece")}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.husband"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.husband"
                              )}
                            </option>
                            <option value={i18next.t("userregistration.step4_select.wife")}>
                              {i18next.t("userregistration.step4_select.wife")}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.sponsoreddependent"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.sponsoreddependent"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.stepson"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.stepson"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.stepdaughter"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.stepdaughter"
                              )}
                            </option>
                            <option value={i18next.t(
                              "userregistration.step4_select.otherrelationship"
                            )}>
                              {i18next.t(
                                "userregistration.step4_select.otherrelationship"
                              )}
                            </option>
                          </select>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}


                  </>
                ) : (
                  <>
                    {checkAndGetLocalStorageValue("careoption") ==
                      telemedicine ? (
                      <textarea
                        name="notes"
                        className="mt-2 contact-notes"
                        rows="4"
                        placeholder={i18next.t(
                          "findcareoption.Careoptions.notes"
                        )}
                        defaultValue={fields.notes}
                      ></textarea>
                    ) : (
                      ""
                    )}

                    {checkAndGetLocalStorageValue("careoption") ==
                      conciergeCare ? (
                      <input
                        type="text"
                        name="mobile"
                        placeholder={i18next.t(
                          "findcareoption.Careoptions.PhoneNumber"
                        )}
                        defaultValue={fields.mobile}
                        className={invalidFields.mobile ? "is-error" : ""}
                      />
                    ) : (
                      ""
                    )}

                    <input
                      type="text"
                      className="extensionOrRoomNumber"
                      name="extensionOrRoomNumber"
                      maxLength="5"
                      pattern="[0-9]+"
                      //value={this.state.value}
                      onChange={this.onChange}
                      placeholder={i18next.t(
                        "findcareoption.Careoptions.ExtensionRoom"
                      )}
                      defaultValue={
                        state.triageRequest.data &&
                          state.triageRequest.data.extensionOrRoomNumber
                          ? state.triageRequest.data.extensionOrRoomNumber.trim()
                          : fields.extensionOrRoomNumber
                      }

                    />
                  </>
                )}
                <button
                  type="submit"
                  className={cx(
                    "button standby-button standby-button-gradient standby-button-full-width standby-button-gradient-green" /* : 'btn-screen-nav--disabled' */
                  )}
                >
                  <Trans i18nKey="findcareoption.Careoptions.Concierge.Next">
                    Next
                  </Trans>
                </button>

                {isValid ? (
                  ""
                ) : (
                  <p className="color-dark-gray text-small">
                    <Trans i18nKey="findcareoption.Careoptions.Concierge.ConciergeValidationMsg">
                      Please make sure to fill all required fields.
                    </Trans>
                  </p>
                )}
              </>
              <div className="standby-page-header standby-page-header-center">
                <Link
                  className="standby-button-back"
                  to={state.UserNavigatedToQT ? `/find-care-options/quick-telemedicine-screen` : '/find-care-options/care-options'}
                >
                  <div className="icon">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      viewBox="0 0 1024 1024"
                    >
                      <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
                    </svg>
                  </div>
                  <Trans i18nKey="findcareoption.Careoptions.telemedicine.Cancelrequest">
                    Cancel Request
                  </Trans>
                </Link>
              </div>
            </div>
          )}
        </Form>
      </div>
    );
  }
}
